import { gql } from '@apollo/client';

import { TrainingSession } from 'src/types/api';

export type TraineeOrInstructorTrainingSessions = {
  user: {
    trainingSessions: Array<Pick<TrainingSession, 'id' | 'name' | 'customName' | 'startDate' | 'endDate' | 'frozenAt'>>;
  };
};

export const TRAINEE_TRAINING_SESSIONS = gql`
  query trainingSessions($id: ID!) {
    user: trainee(id: $id) {
      trainingSessions {
        id
        name
        customName
        startDate
        endDate
        frozenAt
      }
    }
  }
`;

export const INSTRUCTOR_TRAINING_SESSIONS = gql`
  query trainingSessions($id: ID!) {
    user: instructor(id: $id) {
      trainingSessions {
        id
        name
        customName
        startDate
        endDate
        frozenAt
      }
    }
  }
`;
